var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResponsavelFechamento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6944 15.8075C18.7291 16.2605 19.6588 16.9229 20.4249 17.753C20.541 17.8813 20.6071 18.0472 20.6109 18.2202V21.0808C20.6109 21.2705 20.5355 21.4524 20.4014 21.5865C20.2673 21.7207 20.0854 21.796 19.8957 21.796H8.93C8.74197 21.796 8.5615 21.722 8.42765 21.5899C8.2938 21.4579 8.21735 21.2784 8.21484 21.0904V18.2298C8.21634 18.0534 8.28251 17.8838 8.40078 17.753C9.16688 16.9229 10.0966 16.2605 11.1313 15.8075C12.166 15.3544 13.2833 15.1205 14.4128 15.1205C15.5424 15.1205 16.6597 15.3544 17.6944 15.8075Z",
    fill: "#6796CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4116 14.1666C16.2548 14.1666 17.749 12.6724 17.749 10.8292C17.749 8.98602 16.2548 7.49182 14.4116 7.49182C12.5684 7.49182 11.0742 8.98602 11.0742 10.8292C11.0742 12.6724 12.5684 14.1666 14.4116 14.1666Z",
    fill: "#6796CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsavelFechamento);
export default __webpack_public_path__ + "static/media/responsavelFechamento.42d2c032e5f2c4c3422e84b63f525df5.svg";
export { ForwardRef as ReactComponent };